enum InterviewCancelledReason {
    Undefined = 0,
    CreatedByMistake = 1,
    WorkerUnavailable = 2,
    ContactUnavailable = 3,
    WorkerNoLongerInterested = 4,
    ContactNoLongerInterested = 5,
}

export default InterviewCancelledReason;